import {
    setCookie,
    getCookie,
    isFunc,
    n2v
} from '../Often';
import {setLocal, removeLocal, getLocalValue} from '../LocalStorage'
import {toast} from '../Toast';
import {checkFlowVersion, checkFlowNewVersion, autoUpdate} from './download';

const isElectronApp = () => {
    return n2v(getLocalValue("ONLY_ELECTRON_YN"), "N") === "Y";
}

const init = (isLoginState) => {
    if (!isElectronAvailable()) return;
    if (Often.isFunc("DESKTOP_AUTO_UPDATE")) autoUpdate({isSilentUpdate: true});
    openMenuVisibleValue();
    etcLogic();
    setUserInfo();

    function openMenuVisibleValue() {
        if (Often.isMessenger()) return;
        ElectronApi.Window.setMenuVisibleValue({
            logoutMenuVisible: isLoginState,
            lockMenuVisible: isLoginState && _USE_INTT_ID.indexOf("KAKAO") === -1 && _USE_INTT_ID.indexOf("APPLE") === -1 && _USE_INTT_ID.indexOf("GMAIL") === -1,
            windowModeVisible: isLoginState,
            serverMenuVisible: (ServerChecker.isMadras || Often.isServerModeByHost("DEV_TEST"))
        })
    }

    function etcLogic() {
        if (ServerChecker.isSeco || ServerChecker.isZoomok) {
            $('body').off('mouseenter mouseleave mousedown keypress').on('mouseenter mouseleave mousedown keypress', function () {
                MiniLock.setLockState(true);
            });
        }
    }

    function setUserInfo() {
        const writeDnsErrorLog = Often.isFunc('WRITE_ELECTRON_SESSION_ERROR_LOG')

        ElectronApi.Comm.setConfig({'key': 'USER_ID', 'value': _USER_ID})
        ElectronApi.Comm.setConfig({'key': '_USE_INTT_ID', 'value': _USE_INTT_ID})
        ElectronApi.Comm.setConfig({'key': 'writeSessionErrLog', 'value': writeDnsErrorLog})
    }
}


const setConfig = (props) => {
    if(window.ElectronProcessApi) runElectronFunc('ElectronProcessApi', 'setConfig', props);
    else fn_setOneConfigForElectron(props.key, props.value)
}
const getName = () => {
    if (window.ElectronProcessApi) return runElectronFunc('ElectronProcessApi', 'getName');
    else return fn_ElectronNameCheck()
}
const getConfig = (props) => runElectronFunc('ElectronProcessApi', 'getConfig', props);
const getConfigs = () => {
    if (window.ElectronProcessApi) return runElectronFunc('ElectronProcessApi', 'getConfigs');
    return fn_getConfigsForElectron();
}
const getVersion = () => {
    if (window.ElectronProcessApi) return ElectronProcessApi.getVersion();
    else return fn_ElectronVersionCheck();
}
const isElectron = () => n2v(getLocalValue("ONLY_ELECTRON_YN", "N")) === "Y";
const reload = (isClearCache = false) => runElectronFunc('ElectronWindowApi', 'reload', {isClearCache});
const relaunchApp = () => runElectronFunc('ElectronProcessApi', 'relaunchApp');

const isElectronAvailable = () => {
    try {
        const electronVersion = n2v(getVersion(), '');
        setAppDataElectron(electronVersion && electronVersion !== '' ? "Y" : "N", electronVersion);
        return true
    } catch (e) {
        setAppDataElectron("N", '');
        return false
    }
}

const setAppDataElectron = (yn, version) => {
    if (version && version !== '') {
        setCookie("electronVer", version);
        setLocal("ONLY_ELECTRON_VER", version);
    } else {
        removeLocal("ONLY_ELECTRON_VER");
    }
    LocalUtil.setLocal("ONLY_ELECTRON_YN", yn);
    setCookie("electronYn", yn);
}

const runElectronFunc = (moduleName, FuncName, props) => {
    try {
        return window[moduleName][FuncName](props);
    } catch (e) {
        console.error(e);
        toast('error', i18next.t(main.alert.errorTryAgain));
        return false;
    }
}

const showVersionLimit = async () => {
    const appName = await getName();
    if (Often.isFunc(Func.CLOUD.STOP_FLOWNEW) && appName.indexOf('new') > -1) checkFlowNewVersion();
    else if (Often.isFunc(Func.CLOUD.DESKTOP_UPDATE_POPUP)) checkFlowVersion();
}

export {
    init,
    setConfig,
    isElectronApp,
    isElectronAvailable,
    runElectronFunc,
    getConfig,
    getVersion,
    getName,
    isElectron,
    showVersionLimit,
    getConfigs,
    reload,
    relaunchApp,
};
